import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { AppTokenHandler, HTTPStatus } from 'src/app/CommonService/app-token-handler';
import { catchError, finalize } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ProgressService } from './progress.service';

@Injectable()
export class Interceptor implements HttpInterceptor {
    constructor(private appToken: AppTokenHandler, private route: Router,
        private progressService: ProgressService) { }
    public pendingRequests: any = 0;
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.pendingRequests++;
        this.progressService.ChangeProgressStatus(true);
        const access_token_value = this.appToken.getSessionToken();
        if (access_token_value != null) {
            const cloned_req = req.clone({
                headers: req.headers.set('access_token', this.appToken.getSessionToken())
            });
            return next.handle(cloned_req).pipe(catchError((err: HttpErrorResponse) => {
                if (err.status === 401) {
                    console.log(err);
                    this.route.navigate(['/error/1']);
                }
                if (err.status === 417) {
                    this.route.navigate(['/error/3']);
                }
                if (err.status === 404) {
                    this.route.navigate(['/error/5']);
                }
                if (err.status === 408 || err.status === 406) {
                    alert('Your session has been expired.');
                this.route.navigate(['/logout']);
                }

                // const error = err.error.message || err.statusText;
                return throwError(err.statusText);
            }), finalize(() => {
                this.pendingRequests--;
                if (this.pendingRequests <= 0) {
                    this.progressService.ChangeProgressStatus(false);
                }
                return;
            })
            );
        } else {

            this.route.navigate(['/error/1']);
            return of();
        }
    }
}
